export const POSTS_CREATE_MODAL_TOGGLE = 'POSTS_CREATE_MODAL_TOGGLE';
export const POSTS_FAVORITES_REMOVE = 'POSTS_FAVORITES_REMOVE';
export const POSTS_FAVORITES_ADD = 'POSTS_FAVORITES_ADD';
export const POSTS_FILTERS_SET = 'POSTS_FILTERS_SET';
export const POSTS_FETCHED = 'POSTS_FETCHED';
export const POSTS_LOADING = 'POSTS_LOADING';
export const POSTS_CLEAR = 'POSTS_CLEAR';
